export const getDefaultValue = (data) => {
    return data?.find((e) => e.default);
};
